module.exports = __webpack_public_path__ + "static/media/help.79517bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainmenus/help.png
// module id = 1076
// module chunks = 0